export const profile = {
  name: "Erik Schmidt",
  role: "Software Engineer",
  statement:
    "I build reliable interfaces, industrial software and digital products.",
  stack: "React, TypeScript, C#, Avalonia and Flutter.",
  location: "Oradea, Romania",
};

export const projects = [
  {
    number: "01",
    title: "Industrial Production Software",
    description:
      "Desktop interfaces and manufacturing workflows for industrial environments.",
    technologies: "C# / Avalonia / ReactiveUI / Rx.NET",
    year: "2026",
  },
  {
    number: "02",
    title: "NeptunePass",
    description:
      "Web and mobile platform for swimming pool access, tracking and reporting.",
    technologies: "React / Flutter / Supabase",
    year: "2025–2026",
  },
  {
    number: "03",
    title: "Travel Platforms",
    description:
      "Frontend development for international travel and membership platforms.",
    technologies: "React / TypeScript / Material UI",
    year: "2022–2025",
  },
];

export const about = {
  text: "Software engineer focused on practical products, industrial systems and polished user interfaces. I enjoy working between software, hardware and real-world processes.",
  skills: "React · TypeScript · C# · Avalonia · Flutter · SQL · Linux",
  note: "Engineer during the week. Maker during the weekend.",
};

export const experience = [
  {
    company: "Octavic PTS",
    role: "Software Engineer",
    period: "2026 — Present",
    details:
      "Industrial desktop software, manufacturing workflows, hardware integration.",
  },
  {
    company: "Lateral Group",
    role: "Frontend Developer",
    period: "2022 — 2025",
    details:
      "Travel platforms, React applications, design systems and international storefronts.",
  },
];

export const education = [
  "BSc Computer Engineering — University of Oradea",
  "Master’s in Information Technology Management — Ongoing",
];

export const contact = {
  heading: "Let’s build something useful.",
  availability:
    "Available for software engineering, frontend and industrial software projects.",
  links: [
    {
      label: "Email",
      href: "mailto:contact@schmidterik.com",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/search/results/people/?keywords=Erik%20Schmidt%20Oradea",
    },
    {
      label: "GitHub",
      href: "https://github.com/Erik2121",
    },
  ],
};
